import React from 'react';
import Moment from 'moment';
import { Checkbox } from '../elements-checkbox/animated-checkbox';

export class ProjectFormList extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { _id, name, activity, location, schedule, checked, onChange, itemAction, projectId } = this.props;
    const date = schedule && schedule.length ? schedule[0].start.date : null;
    const formattedDate = date ? `${Moment({ month: date.m - 1, day: date.d, year: date.y  }).format('ll')} ·` : '';
    return (
      <div data-id={_id} ref={`project-list-${_id}`} className="project-list-row">
        <div>
          <Checkbox
            clickCB={ onChange }
            itemAction={ itemAction }
            checked={ checked }
            callbackParams={ { projectId: projectId } }
            checkboxKey={ projectId }
          />
        </div>
        <div>
          <div className="text-large">{name}</div>
          {
            activity || formattedDate || location ?
            <div className="text-small text-gray ellipsis">{`${activity} · ${formattedDate} ${location}`}</div> :
            null
          }
        </div>
      </div>
    );
  }
}
